<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h-scroll h-wrapper-680">
        <div class="h-dialogContainer">
          <div class="form-group h-col-inputBox">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('System.os')}}</div>
              <div class="col-md-8">
                <input disabled :value="os" />
              </div>
            </div>
          </div>
          <div class="form-group h-col-inputBox">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('System.version')}}</div>
              <div class="col-md-8">
                <input disabled :value="version" />
              </div>
            </div>
          </div>
          <div class="form-group h-col-inputBox">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('System.ip')}}</div>
              <div class="col-md-8">
                <input disabled :value="ip" />
              </div>
            </div>
          </div>
          <div class="form-group h-col-inputBox">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('System.hostname')}}</div>
              <div class="col-md-8">
                <input disabled :value="hostname" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import { EventBus } from "../../plugins/eventBus";

export default {
  name: "SystemQuery",
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: {
        show: true,
        crumb: `${this.$t("System.systemManager")}/${this.$t(
          "System.systemQuery"
        )}`
      },
      os: "",
      version: "",
      ip: "",
      hostname: ""
    };
  },
  components: {
    BasicLayout
  },
  methods: {
    querySystemInfo() {
      this.$axios.get(`/lte/ems/sysmanager/host/info`).then(response => {
        if (response && response.status === 200) {
          const result = response.data;
          this.os = result.os;
          this.version = result.version;
          this.ip = result.ip;
          this.hostname = result.hostname;
        }
      });
    }
  },
  mounted() {
    this.querySystemInfo();
  }
};
</script>
